module.exports = __webpack_public_path__ + "media/img/specialize/mobile/item14-d5a0aa1f7e002aa83efe31130fc9972c.svg";